import type { BadgeVariant } from '@/components/ui'
import type { PenaltyEntryStatus, PenaltyType } from '@/features/penalties/types/penalty.types'

export function penaltyStatusBadgeVariant(status: PenaltyEntryStatus): BadgeVariant {
  switch (status) {
    case 'pending_approval':
      return 'warning'
    case 'approved':
      return 'success'
    case 'reversed':
      return 'neutral'
    default:
      return 'neutral'
  }
}

export function penaltyStatusLabel(status: PenaltyEntryStatus): string {
  switch (status) {
    case 'pending_approval':
      return 'Pending approval'
    case 'approved':
      return 'Approved'
    case 'reversed':
      return 'Reversed'
    default:
      return status
  }
}

export function resolvePenaltyTypeName(
  penaltyTypeId: string | undefined,
  customTypeName: string | undefined,
  types: PenaltyType[],
  penaltyTypeName?: string,
): string {
  if (customTypeName) return customTypeName
  if (penaltyTypeName) return penaltyTypeName
  if (penaltyTypeId) {
    const found = types.find((t) => t._id === penaltyTypeId)
    return found?.name ?? penaltyTypeId
  }
  return '—'
}

export function resolveEmployeeName(
  employeeName: string | undefined,
  employeeId: string | undefined,
  userId: string,
): string {
  if (employeeName && employeeId) return `${employeeName} (${employeeId})`
  return employeeName ?? employeeId ?? userId
}
